import React from "react";
import styles from "../PreviewV3.module.css";

export default function SwmsContentManagementType({ sectionData, displayName, sectionNumber, targetId }) {
  const safeSectionData = sectionData || {};

  return (
    <div className={styles.PreviewSectionBlock} id={targetId} style={{ scrollMarginTop: "140px" }}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={`${styles.PreviewRichText} preview-swms-v3-rich-text`} dangerouslySetInnerHTML={{ __html: safeSectionData.description || "" }}></div>
      </div>
    </div>
  );
}